import styled from 'styled-components';

import IncidentsCell from './container';

export default styled(IncidentsCell)`
  padding: 0;
`;
